__turbopack_context__.v({
  "bottom": "digital-text-field-cell-module-scss-module__jsjAeW__bottom",
  "box": "digital-text-field-cell-module-scss-module__jsjAeW__box",
  "digital-text-field-blink": "digital-text-field-cell-module-scss-module__jsjAeW__digital-text-field-blink",
  "digital-text-field-cell": "digital-text-field-cell-module-scss-module__jsjAeW__digital-text-field-cell",
  "error": "digital-text-field-cell-module-scss-module__jsjAeW__error",
  "fill": "digital-text-field-cell-module-scss-module__jsjAeW__fill",
  "focus": "digital-text-field-cell-module-scss-module__jsjAeW__focus",
});
